import { gql } from '@apollo/client';

export const GetRecordingUri = gql`
    query getRecordingUri($callSid: String!) {
        getRecordingUri(callSid: $callSid) {
            ... on CallActivityType {
                recordingUri
            }
        }
    }
`;
